import {
  DeploymentPostProcessingParameters,
  RealtimePostProcessingParameters,
  RealtimePreProcessingParameters,
  TestParametersAccordion,
} from '../DeployConfigPanel/TestDeployParameters';
import {setStreamingTask, useDeploy} from '../useDeploy';
import React from 'react';
import {useIntl} from 'react-intl';
import {VideoStreamController} from '../HlsVideoStream';

export type TestResultParametersProps = {
  projectId: string;
  applicationId: string;
  spaId?: string;
  useStreamingTask: boolean;
  videoController?: VideoStreamController;
};

export const TestResultParameters = ({
  projectId,
  applicationId,
  spaId,
  useStreamingTask,
  videoController,
}: TestResultParametersProps) => {
  const intl = useIntl();
  const [, dispatch] = useDeploy();

  return (
    <>
      <TestParametersAccordion
        title={intl.formatMessage({id: 'test.form.rtpreprocessing'})}
        className="test-inference-results__accordion"
      >
        <RealtimePreProcessingParameters
          className="test-inference-results__form"
          projectId={projectId}
          applicationId={applicationId}
          renderField={(field, param) => (
            <div className="test-inference-results__field" key={param.id}>
              {field}
            </div>
          )}
          emptyMessage={
            <div className="test-inference-results__empty">
              {intl.formatMessage({id: 'test.form.preprocessing.empty'})}
            </div>
          }
          onChange={parameters => {
            if (useStreamingTask) {
              dispatch(setStreamingTask({realtimePostProcessorParameters: parameters}));
            } else {
              videoController?.updateParameters(parameters);
            }
          }}
        />
      </TestParametersAccordion>
      <TestParametersAccordion
        title={intl.formatMessage({id: 'test.form.rtpostprocessing'})}
        className="test-inference-results__accordion"
      >
        <RealtimePostProcessingParameters
          className="test-inference-results__form"
          projectId={projectId}
          applicationId={applicationId}
          spaId={spaId}
          renderField={(field, param) => (
            <div className="test-inference-results__field" key={param.id}>
              {field}
            </div>
          )}
          emptyMessage={
            <div className="test-inference-results__empty">
              {intl.formatMessage({id: 'test.form.postprocessing.empty'})}
            </div>
          }
          onChange={parameters => {
            if (useStreamingTask) {
              dispatch(setStreamingTask({realtimePostProcessorParameters: parameters}));
            } else {
              videoController?.updateParameters(parameters);
            }
          }}
        />
      </TestParametersAccordion>
      <DeploymentPostProcessingParameters
        className="test-inference-results__form"
        disabledForm
        projectId={projectId}
        applicationId={applicationId}
        spaId={spaId}
        renderField={(field, param) => (
          <div className="test-inference-results__field" key={param.id}>
            {field}
          </div>
        )}
        titleMessageId="test.form.deploypostprocessing"
        wrapperClassName="test-inference-results__accordion"
        detailsClassName="deploy-settings__body_container"
        onChange={() => {}}
      />
    </>
  );
};
